<template>
  <div class="bNews">
    <div class="bNews__container container pt-4">
      <div class="bNews__header row">
        <div class="bNews__header__h2 h2 col">最新消息</div>
      </div>
      <div class="bNews__body d-flex flex-column align-items-center">
        <form class="w-100 pb-3"
        @submit.prevent="add_new_news">
            <b-button
            v-b-toggle="'newNews'"
            class="btn-info m-1 w-100 d-flex flex-column align-items-center">
              新增新聞
            </b-button>
            <b-collapse id="newNews">
              <b-card class="p-1">
                <div class="form-group d-flex justify-content-end">
                  <button class="btn btn-info mr-3"
                  type="submit">
                    新增新聞
                  </button>
                  <button class="btn btn-danger"
                  @click.prevent="create_new_news">
                    清除重填
                  </button>
                </div>
                <div class="form-group">
                  <label>新聞標題</label>
                  <input type="text"
                  class="form-control"
                  v-model="newNews.title"
                  required>
                </div>
                <div class="form-group">
                  <label>新聞描述</label>
                  <ckeditor
                  :editor="ckEditorType"
                  v-model="newNews.description"></ckeditor>
                </div>
                <div class="form-group">
                  <label>新聞內容</label>
                  <ckeditor
                  :editor="ckEditorType"
                  v-model="newNews.content"></ckeditor>
                </div>
                <div class="form-group">
                  <label>新聞備註</label>
                  <ckeditor
                  :editor="ckEditorType"
                  v-model="newNews.remark"></ckeditor>
                </div>
              </b-card>
            </b-collapse>
        </form>
        <form class="w-100 pb-3"
        v-for="(item, index) in news"
        :key="index"
        @submit.prevent="edit_news(item)">
            <b-button
            v-b-toggle="item.id"
            class="m-1 w-100 d-flex flex-column align-items-center">
              <span class="pb-2">{{item.date}}</span>
              <span>{{item.title}}</span>
            </b-button>
            <b-collapse :id="item.id">
              <b-card class="p-1">
                <div class="form-group d-flex justify-content-end">
                  <button class="btn btn-info mr-3"
                  type="submit">
                    儲存變更
                  </button>
                  <button class="btn btn-danger"
                  @click.prevent="delete_news(item.id)">
                    刪除新聞
                  </button>
                </div>
                <div class="form-group">
                  <label>新聞標題</label>
                  <input type="text"
                  class="form-control"
                  v-model="item.title"
                  required>
                </div>
                <div class="form-group">
                  <label>新聞描述</label>
                  <ckeditor
                  :editor="ckEditorType"
                  v-model="item.description"></ckeditor>
                </div>
                <div class="form-group">
                  <label>新聞內容</label>
                  <ckeditor
                  :editor="ckEditorType"
                  v-model="item.content"></ckeditor>
                </div>
                <div class="form-group">
                  <label>新聞備註</label>
                  <ckeditor
                  :editor="ckEditorType"
                  v-model="item.remark"></ckeditor>
                </div>
              </b-card>
            </b-collapse>
        </form>
      </div>
    </div>
  </div>
</template>

<style>
  .ck-editor__editable {
    min-height: 200px;
    resize: vertical;
   }
</style>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data() {
    return {
      news: [],
      newNews: {
        id: '',
        title: '',
        date: '',
        description: '',
        banner: '',
        content: '',
        remark: '',
      },
      ckEditorType: ClassicEditor,
    };
  },
  methods: {
    initialize_news() {
      let oriNews;
      this.$bus.$on('son_get_data', (data) => {
        oriNews = JSON.parse(JSON.stringify(data.news));
      });
      this.$bus.$emit('son_call_data');
      oriNews.sort((a, b) => {
        const numA = JSON.parse(a.id.slice(-8));
        const numB = JSON.parse(b.id.slice(-8));
        return numB - numA;
      });
      this.news = oriNews;
    },
    create_new_news() {
      this.newNews = {
        id: '',
        title: '',
        date: '',
        description: '',
        banner: '',
        content: '',
        remark: '',
      };
      const nDate = new Date();
      const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = date.getMonth() + 1;
        const dd = date.getDate();
        return `${yyyy}-${(mm > 9 ? '' : '0') + mm}-${(dd > 9 ? '' : '0') + dd}`;
      };
      const formatId = (date) => {
        const yyyy = date.getFullYear();
        const mm = date.getMonth() + 1;
        const dd = date.getDate();
        return `NEW${yyyy}${(mm > 9 ? '' : '0') + mm}${(dd > 9 ? '' : '0') + dd}`;
      };
      const formatIdUnique = (dateIdStr) => {
        const repeatedArr = this.news.filter((item) => item.id.includes(dateIdStr));
        const repeatedLength = repeatedArr.length;
        const index = (repeatedLength + 1 > 9 ? '' : '0') + (repeatedLength + 1);
        return index;
      };
      this.newNews.id = `${formatId(nDate)}${formatIdUnique(formatId(nDate))}`;
      this.newNews.date = formatDate(nDate);
    },
    add_new_news() {
      this.$bus.$emit('add_new_news', this.newNews);
      this.initialize_news();
      this.create_new_news();
    },
    edit_news(newsObj) {
      this.$bus.$emit('edit_news', newsObj);
      this.initialize_news();
    },
    delete_news(newsId) {
      this.$bus.$emit('delete_news', newsId);
      this.initialize_news();
    },
  },
  created() {
    this.initialize_news();
    this.create_new_news();
  },
};
</script>
